<template>
    <div>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group>
                    <label>Situação</label>
                    <model-list-select
                        :list="situacoes"
                        option-text="situacao"
                        option-value="codigo"
                        v-model="situacao"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col> 
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Status</label>
                    <model-list-select
                        :list="statusVencimentos"
                        option-text="status"
                        option-value="codigo"
                        v-model="status"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col> 
            <b-col class="mt-4 pt-1">
                <b-button variant="primary" @click="pesquisar()"
                    >Pesquisar</b-button
                >
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import ContratosServicos from './ContratosServicos'

export default {
    data() {
        return {
            situacoes: [],
            situacao: 0,
            statusVencimentos: [],
            status: 0
        }
    },

    components: {
        ModelListSelect
    },

    methods: {
        obterOpcoesFiltros() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.situacoes = response.data.situacoes
                        this.situacoes.unshift({
                            codigo: 0,
                            situacao: 'Todos'
                        })
                        this.statusVencimentos = response.data.statusVencimentos
                        this.statusVencimentos.unshift({
                            codigo: 0,
                            status: 'Todos'
                        })
                        this.$emit('atualizarFiltro', this.filtro)
                        this.$emit('pesquisar')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar() {
            this.$emit('pesquisar')
        }
    },

    mounted() { 
        this.obterOpcoesFiltros()
    },
    
    watch: {
        situacao() {
            this.$emit('atualizarFiltro', this.filtro)
        },

        status() {
            this.$emit('atualizarFiltro', this.filtro)
        }
    },

    computed: {
        filtro() {
            return {
                situacao: this.situacao,
                status: this.status
            }
        }
    }
}
</script>